@if (content.copy.length > 0){
<div class="p-20 bg-primary-500 flex md:flex-row flex-col gap-8">
	@for (item of content.copy; track item.title) {
	<div class="flex flex-col flex-1 gap-4">
		<div class="text-5xl text-surface-0 font-medium leading-tight text-center">{{ item.title }}</div>
		<div class="text-xl text-surface-200 font-normal leading-normal text-center">{{ item.description }}</div>
	</div>
	}
</div>
}
